//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GameBox from "./GameBox";
import Loader from "../../loaders/Loader";

export default {
  name: "game-list",
  components: {Loader, GameBox},
  props: {
    type: {
      default: 'calendar',
      type: String
    },
    days: {
      default: false,
      type: Boolean,
    },
    url: {
      default: null,
      type: String,
    },
    prerended: {
      default: false,
      type: Boolean,
    },
    logos: {
      default: true,
      type: Boolean,
    },
    rugbyzone: {
      default: false,
      type: Boolean,
    },
    displayWinamax: {
      default: true,
      type: Boolean,
    }
  },
  //props: ['type', 'days', 'url'],
  data() {
    return {
      games: [],
      order: 'asc',
      loader: false,

      day: null,
      daysList: [],
      getUrl: null,
      prerender: false,
      winamax: [],
      displayAds: true,
      advertiser: null,
    }
  },
  created() {
    this.displayAds = this.$root.display;
    this.advertiser = window.rugbyAdvertiser;

    this.getUrl = this.url;
    this.order = this.type === 'calendar' ? 'asc' : 'desc';
    this.loader = true;
    this.prerender = this.prerended;
    if( this.url != null ) {
      this.getGames();
    }
  },
  methods: {
    getGames() {
      window.Api.get(this.getUrl).then(response => {
        if( this.prerender ) {
          $('#prerended-games').remove();
        }
        this.games = response.data.games;
        if( response.data.day && response.data.days ) {
          this.day = response.data.day;
          this.daysList = response.data.days;
        }

        this.loader = false;
        this.prerender = false;
      });
    },

    sortGames(order) {
      if( order !== this.order ) {
        this.order = order;
        this.games = this.games.reverse();
      }
    },

    selectDay() {
      this.games = [];
      this.getUrl = this.url + '?round=' + this.day;
      this.loader = true;
      this.getGames();
    }
  }
}
